import { Button } from '@ordo/ui/button'
import { EmptyState } from '@ordo/ui/empty-state'
import { AlertTriangle } from 'lucide-react'

/**
 * Root `errorElement`. Two jobs:
 *
 *  1. Users get something they can act on instead of react-router's raw
 *     error dump (message + stack rendered straight onto the page).
 *  2. It displaces react-router's `DefaultErrorComponent`, whose
 *     `console.error('Error handled by React Router default ErrorBoundary:')`
 *     was the largest single client-exception family in Loki — 552 events in
 *     7 days, one extra alert hash for every render error in the app.
 *     (It logs unconditionally because react-router ships its development
 *     build to production; see the exports-map note in the audit summary.)
 *
 * Deliberately does NOT report the error. `onError` on `<RouterProvider>`
 * (main.tsx) is the single reporting site — it fires once per error rather
 * than on every re-render of this component.
 */
export function RouteError() {
  return (
    <EmptyState
      icon={<AlertTriangle />}
      title="Something went wrong"
      description="This page didn't load correctly. Reloading usually fixes it."
      action={
        <Button
          onClick={() => {
            window.location.reload()
          }}>
          Reload page
        </Button>
      }
    />
  )
}
